import React, { useEffect, useState } from "react";
import {
  Text4,
  UploadField,
} from "../../../Components/FormComponents/InputFields";
import { useForm, useWatch } from "react-hook-form";
import { Button, Col, notification, Row } from "antd";
import {
  BankDetailAPI,
  uploadDocumentsAPI,
} from "../../../Services/EmployeeOnboarding";
import { useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

export default function BankDetails({ current, setCurrent }) {
  const {
    control,
    handleSubmit,
    reset,
    getValues,
    watch,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });
  const { responseData, profileData, id } = useOutletContext();
  const [disabledFields, setDisabledFields] = useState("");

  const [validateData, setValidateData] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const navigate = useNavigate(null);
  const [api, contextHolder] = notification.useNotification();

  const chequeFile = useWatch({
    control,
    name: "cancelled_cheque",
  });

  useEffect(() => {
    const uploadCheque = async () => {
      if (!chequeFile || !(chequeFile instanceof File)) return;

      const formData = new FormData();
      formData.append("cancelled_cheque", chequeFile);

      try {
        await uploadDocumentsAPI(formData);
      } catch (err) {
        console.error("Upload failed", err);
      }
    };

    uploadCheque();
  }, [chequeFile]);

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      if (!isAllFieldsValid()) {
        api.error({
          message: "Validation Error",
          description: "Please fill all required bank details and upload your cancelled cheque/passbook.",
          placement: "top",
        });
        setLoading(false);
        return;
      }

      if (!val.cancelled_cheque) {
        api.error({
          message: "Please upload cancelled cheque",
          placement: "top",
        });
        setLoading(false);
        return;
      }

      const payload = {
        bank_name: val.bank_name,
        account_number: val.account_number,
        ifsc_code: val.ifsc_code,
        beneficiary_name: val.beneficiary_name,
        branch_name: val.branch_name,
        branch_address: val.branch_address || "",
        verified_name: validateData?.full_name || val.beneficiary_name || "",
      };
      const res = await BankDetailAPI(payload);
      console.log("Bank details submitted:", res.data);
      if (res.data?.success) {
        console.log(responseData?.final_submit);
        if (responseData?.final_submit) {
          await handleSubmitFinal();
        } else {
          navigate("/new-user/documents");
        }
        navigate("/new-user/documents");
      } else {
        if (res?.data?.message === "Bank details already updated") {
          navigate("/new-user/documents");
        } else {
          api.error({
            message: res?.data?.message || "Something went wrong",
            placement: "top",
          });
        }
      }
    } catch (error) {
      console.error("Error submitting bank details:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitFinal = async () => {
    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
      sections: ["bank_details"],
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/documents");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };
  const type = localStorage.getItem("userType");

  useEffect(() => {
    const disableFields = {};
    const getValue = (path) => {
      const getNestedValue = (obj, pathArr) => {
        return pathArr.reduce(
          (acc, key) => (acc && acc[key] !== undefined ? acc[key] : null),
          obj,
        );
      };
      const profileVal = getNestedValue(profileData, path);
      const responseVal = getNestedValue(responseData, path);
      const fieldKey = path.join(".");

      if (
        profileVal !== null &&
        profileVal !== undefined &&
        profileVal !== ""
      ) {
        disableFields[fieldKey] = true;
        return profileVal;
      }

      return responseVal;
    };

    const updatedValues = {
      account_number: getValue(["bank_details", "account_number"]) || "",
      bank_name: getValue(["bank_details", "bank_name"]) || "",
      beneficiary_name: getValue(["bank_details", "beneficiary_name"]) || "",
      branch_address: getValue(["bank_details", "branch_address"]) || "",
      branch_name: getValue(["bank_details", "branch_name"]) || "",
      ifsc_code: getValue(["bank_details", "ifsc_code"]) || "",
      cancelled_cheque: getValue(["documents", "personal_documents", "cancelled_cheque_passbook", "url"]) || "",
    };

    setDisabledFields((prev) => ({
      ...prev,
      ...disableFields,
    }));

    reset(updatedValues);
  }, [reset, responseData, profileData]);

  const shouldDisableFields = (sectionMeta) => {
    if (!sectionMeta) return false;
    return sectionMeta.final_submit === true;
  };

  const { bank_details_meta } = responseData?.final_submit || {};

  const is_Final_submit = bank_details_meta?.final_submit === true;

  const disabledBankDetail = shouldDisableFields(bank_details_meta);

  const isFieldDisabled = (fieldName) => {
    if (disabledFields[fieldName]) return true;
    if (!disabledBankDetail) return false;

    // Check if the field is flagged for correction
    const isFlagged = responseData?.flagged_fields?.some(
      (f) => f.id === fieldName
    );
    return !isFlagged;
  };

  const allFormValues = watch();

  const isAllFieldsValid = () => {
    return (
      allFormValues.account_number &&
      allFormValues.ifsc_code &&
      allFormValues.beneficiary_name &&
      allFormValues.bank_name &&
      allFormValues.branch_name &&
      allFormValues.cancelled_cheque
    );
  };

  const hasFlaggedFields = responseData?.flagged_fields?.some((f) =>
    f.id.startsWith("bank_details.") || f.id === "cancelled_cheque"
  );

  return (
    <>
      {contextHolder}
      <h3 className="color-heading mb-4">Bank Details</h3>
      <form className="h-full" onSubmit={handleSubmit(onSubmit)}>
        <div className=" border rounded-xl bg-white shadow-md">
          {/* HEADER */}

          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(0)}
          >
            <h3 className="color-heading2">BANK ACCOUNT</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 0 ? "rotate-180" : ""
                }`}
            />
          </div>

          {/* BODY */}
          {activeIndex === 0 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <Row className="align-content-start w-full ">
                <Text4
                  control={control}
                  id="account_number"
                  name="Account Number"
                  disabled={isFieldDisabled("bank_details.account_number")}
                  errors={errors}
                  className="py-2"
                  validations={{
                    required: true,
                  }}
                />
                <Text4
                  control={control}
                  id="ifsc_code"
                  name="IFSC Code"
                  disabled={isFieldDisabled("bank_details.ifsc_code")}
                  errors={errors}
                  className="py-2"
                  validations={{
                    required: true,
                  }}
                />

                <Text4
                  control={control}
                  id="beneficiary_name"
                  name="Account Holder's Name"
                  // disabled={disabledFields["bank_details.beneficiary_name"]}
                  disabled={isFieldDisabled("bank_details.beneficiary_name")}
                  errors={errors}
                  className="py-2"
                  validations={{
                    required: true,
                  }}
                />
                <Text4
                  control={control}
                  id="bank_name"
                  name="Bank Name"
                  disabled={isFieldDisabled("bank_details.bank_name")}
                  errors={errors}
                  className="py-2"
                  validations={{
                    required: true,
                  }}
                />
                <Text4
                  control={control}
                  id="branch_name"
                  disabled={isFieldDisabled("bank_details.branch_name")}
                  name="Branch Name"
                  errors={errors}
                  className="py-2"
                  validations={{
                    required: true,
                  }}
                />

                <Text4
                  control={control}
                  id="branch_address"
                  name="Branch Address"
                  disabled={isFieldDisabled("bank_details.branch_address")}
                  errors={errors}
                  className="py-2"
                  validations={{
                    required: false,
                  }}
                />
              </Row>
              <UploadField
                id="cancelled_cheque"
                name="Cancelled Cheque / Passbook"
                className={"w-full mt-0"}
                control={control}
                errors={errors}
                disabled={isFieldDisabled("cancelled_cheque")}
                validations={{
                  required: true,
                }}
              />
            </div>
          )}
        </div>
        <Row className="step-buttons-box justify-end pt-3 px-2" style={{ borderTop: '1px solid #e5e7eb' }}>
          <button
            type="button"
            className="my-2 step-button back-button mr-2"
            style={{ backgroundColor: "#FFFFFF", color: "#A4A4A4", border: "1px solid #A4A4A4" }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </button>
          <button
            disabled={(is_Final_submit && !hasFlaggedFields) || loading}
            className="my-2 text-white step-button"
            type="submit"
          >
            {loading ? "Processing..." : "Save & Continue"}
          </button>
        </Row>
      </form>
    </>
  );
}
